
import browser from '@beastshop/browser'
const {
  getEnv,
  navigateBack,
  navigateTo,
  postMessage,
  reLaunch,
  redirectTo,
  switchTab
} = wx.miniProgram

export function getMiniEnv () {
  return new Promise((resolve, reject) => {
    if (browser.weixin()) {
      getEnv(res => {
        resolve(res.miniprogram)
      })
    }
    else {
      resolve(false)
    }
  })
}

export function navigateToMini ({
  url,
  type = 'navigate'
}) {
  open({
    url,
    type
  })
}

export function postMessageToMini (postData) {
  postMessage(postData)
}

const METHOD_MAP = {
  navigate: {
    delta: 1,
    method: 'navigateTo'
  },
  redirect: {
    delta: 0,
    method: 'redirectTo'
  },
  tab: {
    delta: 0,
    method: 'switchTab'
  }
}


const stack_await_resolves = []

const stack_has_data = []
const stack_data = []


const stack_has_data_left = []
const stack_data_left = []
const stack_last_action = []

function open ({
  url,
  type = 'navigate',
  data
}, i) {

  const {
    method,
    delta
  } = METHOD_MAP[type] || {}

  if (!method) {
    return Promise.reject(`unsupported open type "${type}"`)
  }

  if (data !== undefined) {
    stack_has_data[i] = true
    stack_data[i] = data
  }

  stack_last_action[i + delta] = type

  return new Promise((resolve, reject) => {
    stack_await_resolves[i] = resolve

    wx.miniProgram[method]({
      url,
      fail (e) {
        clean(i)
        reject(e)
      }
    })
  })
}

function resolve_data (index) {
  const child_index = index + 1
  const data_left = stack_has_data_left[child_index]
    ? stack_data_left[child_index]
    : undefined

  clean_left(child_index)

  const resolve = stack_await_resolves[index]
  delete stack_await_resolves[index]

  if (!resolve) {
    return
  }

  data_left === undefined
    ? resolve()
    : resolve(data_left)
}


function clean (i) {
  delete stack_await_resolves[i]
  clean_data(i)
}

function clean_data (i) {
  delete stack_has_data[i]
  delete stack_data[i]
}

function clean_left (i) {
  delete stack_has_data_left[i]
  delete stack_has_data[i]
}





// WEBPACK FOOTER //
// ./static/miniprogram/index.js